export const aloneApi = {
  getSessionId: { // 获取session-id
      method: 'get',
      api: 'user/index/getSessionId'
  },
  login: { // 登录
      method: 'post',
      api: 'user/index/login'
  },
  getLoginStatus: { // 获取当前登录状态
    method: 'get',
    api: 'user/index/loginStatus'
  },
  logout: { // 获取当前登录状态
    method: 'get',
    api: 'user/index/logout'
  },
}